<template>
 <div>
    <div class="container" >
        <div class="row contact_row">
            <div class="col-12 col-md-12 no-padding welcome_text ">
                <div class="actionsWrapper">
                    <ul class="actionsList">
                        <li @click="statementEmail">
                            Email
                        </li>
                        <li @click="statementCall">
                            Call
                        </li>
                        <li @click="statementVisit">
                            Visit
                        </li>
                    </ul>
                    <div class="actionsContainer">
                        <div v-show="showStatementEmail" class="actionContent">
                            <p>
                                <a href="mailto:hello@pixney.com">hello@pixney.com</a>
                            </p>
                        </div>
                        <div v-show="showStatementCall" class="actionContent">
                            <p>
                                <a href="tel:+46704664339">+46-704664339</a>
                            </p>
                        </div>
                        <div v-show="showStatementVisit" class="actionContent">
                            <p>
                                Litsvägen 25 <br>
                                831 42 Östersund <br>
                                Sweden
                            </p>
                        </div>
                    </div>
                </div>
                <div class="changingTextWrapper">
                    <transition name="fade">
                        <div v-show="showStatementEmail" class="statement statement__email">
                            <h2>Send us an email <i>to start the conversation</i></h2>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="showStatementCall" class="statement statement__call">
                        <h2>Call us <i>to discuss a new project</i></h2>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="showStatementVisit" class="statement statement__visit">
                            <h2>Drop by <i>and say hello!</i></h2>
                        </div>
                    </transition>
                </div>
                <div class="timeWrapper">
                    <h5 id="time">17:05:05</h5>
                    <div class="timeMessage">
                        {{timeMessage}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- <div>
    <div class="container" >
        <div class="row">
            <div class="col-12 col-md-12 no-padding welcome_text ">
                <div class="changingTextWrapper">
                    <transition name="fade">
                        <div v-show="showStatementEmail" class="statement statement__email">
                            <h2>Email us <i>to start the conversation</i></h2>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="showStatementCall" class="statement statement__call">
                            <h2>Call us <i>to discuss a project</i></h2>
                        </div>
                    </transition>
                    <transition name="fade">
                        <div v-show="showStatementVisit" class="statement statement__visit">
                            <h2>Drop by <i>and say hello!</i></h2>
                        </div>
                    </transition>
                </div>
                <div class="actionsWrapper">
                    <ul class="actionsList">
                        <li @click="statementEmail">
                            Email
                        </li>
                        <li @click="statementCall">
                            Call
                        </li>
                        <li @click="statementVisit">
                            Visit
                        </li>
                    </ul>
                    <div class="actionsContainer">
                        <div v-show="showStatementEmail" class="actionContent">
                            <p>
                                <a href="mailto:hello@pixney.com">hello@pixney.com</a>
                            </p>
                        </div>
                        <div v-show="showStatementCall" class="actionContent">
                            <p>
                                <a href="tel:+46-702-153836">+46-702-153836</a>
                            </p>
                        </div>
                        <div v-show="showStatementVisit" class="actionContent">
                            <p>
                                Litsvägen 25 <br>
                                831 42 Östersund <br>
                                Sweden
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-12 no-padding contact_info">              <div class="actionsWrapper hidden-sm-down">
                    <ul class="actionsList">
                        <li @click="statementEmail">
                            Email
                        </li>
                        <li @click="statementCall">
                            Call
                        </li>
                        <li @click="statementVisit">
                            Visit
                        </li>
                    </ul>
                    <div class="actionsContainer">
                        <div v-show="showStatementEmail" class="actionContent">
                            <p>
                                <a href="mailto:hello@pixney.com">hello@pixney.com</a>
                            </p>
                        </div>
                        <div v-show="showStatementCall" class="actionContent">
                            <p>
                                <a href="tel:+46-702-153836">+46-702-153836</a>
                            </p>
                        </div>
                        <div v-show="showStatementVisit" class="actionContent">
                            <p>
                                Litsvägen 25 <br>
                                831 42 Östersund <br>
                                Sweden
                            </p>
                        </div>
                    </div>
                </div> 
                <div class="timeWrapper">
                    <h5 id="time">17:05:05</h5>
                    <div class="timeMessage">
                        {{timeMessage}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
</template>

<script>
  export default {
    props: ['timeMessages'],

    data() {
      return {
        showStatementEmail: true,
        showStatementCall: false,
        showStatementVisit: false,
        timeMessage:'Default'
      }
    },

    computed: {
      
    },

    methods: {

      setTimeMessage: function(h) {

        if(this.timeMessages) {
          var i = 0;
          for (i = 0; i < this.timeMessages.length; i++) { 
            if(this.timeMessages[i].hour==h) {
              this.timeMessage = this.timeMessages[i].message;
            }
          }
        }
        
      },
      
      resetStates: function() {
        this.showStatementEmail = false;
        this.showStatementCall  = false;
        this.showStatementVisit = false;
      },
      statementCall: function() {
        this.resetStates();
        this.showStatementCall=true;
      },
      statementEmail: function() {
        this.resetStates();
        this.showStatementEmail=true;
      },
      statementVisit: function() {
        this.resetStates();
        this.showStatementVisit=true;
      },
      getTime: function() {
        var today = new Date();
        return today.getSeconds();
      },
      checkMessages: function() {
        var today = new Date();
        var h = today.getHours();
        this.setTimeMessage(h);
        var t = setTimeout(this.checkMessages, 1000);
      },
      startTime: function() {
        var today = new Date();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();
        m = this.checkTime(m);
        s = this.checkTime(s);
        document.getElementById('time').innerHTML =
        h + ":" + m + ":" + '<span>'+s+'</span>';
        var t = setTimeout(this.startTime, 500);
      },
      checkTime: function(i) {
         if (i < 10) {i = "0" + i};  // add zero in front of numbers < 10
         return i;
       },

    },
    
    mounted() {
      this.startTime();
      this.checkMessages();
      console.log('i am mounted.');
    }
  }
</script>
